import Vue from 'vue'
import Router from 'vue-router'
import Home from '../Home'
import AboutUs from '../AboutUs'
import InstitutionalDynamics from '../InstitutionalDynamics'
import DynamicsDetails from '../DynamicsDetails'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/AboutUs',
            name: 'AboutUs',
            component: AboutUs
        },
        {
            path: '/InstitutionalDynamics/:type',
            name: 'InstitutionalDynamics',
            component: InstitutionalDynamics,
        },
        {
            path: '/DynamicsDetails/:newsId',
            name: 'DynamicsDetails',
            component: DynamicsDetails
        },
        {
            path: '*',
            redirect: '/',
            component: Home
        }
    ]
})

router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
        // safari
        // window.pageYOffset = 0
    next()
})
export default router;